import type { Command } from '@atlaskit/editor-common/types';
import type { Transaction } from '@atlaskit/editor-prosemirror/state';

import { MoveAnalyticPluginTypes } from './actions';
import { createCommand, getPluginState } from './plugin-factory';
import { pluginKey } from './plugin-key';
import type { ActionType, ContentMoved } from './types';

export const updateContentMoved = (
	nextState: Omit<ContentMoved, 'currentActions'>,
	nextAction: ActionType,
): Command =>
	createCommand(
		(state) => {
			const { contentMoved } = getPluginState(state);

			const data = {
				currentActions: [...contentMoved.currentActions, nextAction],
				size: nextState?.size || contentMoved.size,
				nodeDepth: nextState?.nodeDepth,
				nodeTypes: nextState?.nodeTypes,
				hasSelectedMultipleNodes: nextState?.hasSelectedMultipleNodes,
			};

			return {
				type: MoveAnalyticPluginTypes.UpdateMovedAction,
				data,
			};
		},
		(tr) => tr.setMeta('addToHistory', false),
	);

export const resetContentMoved = (): Command =>
	createCommand(
		() => {
			return {
				type: MoveAnalyticPluginTypes.RemoveMovedAction,
			};
		},
		(tr) => tr.setMeta('addToHistory', false),
	);

export const resetContentMovedTransform =
	() =>
	(tr: Transaction): Transaction => {
		const payload = {
			type: MoveAnalyticPluginTypes.RemoveMovedAction,
		};

		return tr.setMeta(pluginKey, payload);
	};
